<script setup lang="ts">
import { onBeforeMount, ref } from 'vue'
import AppMenuItem from './AppMenuItem.vue'
import { useAuthStore } from '@/stores/authStore.ts'

const currentUserLevel = ref('')

onBeforeMount(async () => {
  currentUserLevel.value = useAuthStore().userRole()
})

const isVisibleFromPermissions = (item: any) => {
  if (item.admit_user_levels.length === 0) {
    return true
  }
  return item.admit_user_levels.includes(currentUserLevel.value)
}

const model = ref([
  {
    admit_user_levels: [],
    label: 'Home',
    items: [
      {
        label: 'Dashboard',
        icon: 'pi pi-fw pi-home',
        to: '/',
        admit_user_levels: []
      }
    ]
  },
  {
    admit_user_levels: ['super_admin', 'admin'],
    label: 'Gestione',
    items: [
      {
        label: 'Amministratori',
        icon: 'pi pi-shield',
        to: '/administrators',
        admit_user_levels: ['super_admin']
      },
      {
        label: 'Clienti',
        icon: 'pi pi-users',
        to: '/customers',
        admit_user_levels: ['super_admin', 'admin']
      },
      {
        label: 'Operatori',
        icon: 'pi pi-cog',
        to: '/operators',
        admit_user_levels: ['super_admin', 'admin']
      },
      {
        label: 'E-mail aggiuntive',
        icon: 'pi pi-envelope',
        to: '/additional_emails',
        admit_user_levels: ['super_admin']
      },
      {
        label: 'Dogane',
        icon: 'pi pi-shopping-bag',
        to: '/customs_offices',
        admit_user_levels: ['super_admin', 'admin']
      },
      {
        label: 'Note',
        icon: 'pi pi-pen-to-square',
        to: '/notes',
        admit_user_levels: ['super_admin']
      },
      {
        label: 'Filtri',
        icon: 'pi pi-filter',
        to: '/filters',
        admit_user_levels: ['super_admin', 'admin']
      }
    ]
  },
  {
    admit_user_levels: [],
    label: 'Centraline',
    items: [
      {
        label: 'Anomalie dispositivi',
        icon: 'pi pi-exclamation-triangle',
        to: '/device_anomalies',
        class: 'rotated-icon',
        admit_user_levels: []
      },
      {
        label: 'Dispositivi',
        icon: 'pi pi-tablet',
        to: '/devices',
        class: 'rotated-icon',
        admit_user_levels: []
      },
      {
        label: 'Trasmissioni',
        icon: 'pi pi-arrow-right-arrow-left',
        to: '/transmissions',
        admit_user_levels: []
      }
    ]
  },
  {
    admit_user_levels: [],
    label: 'Registri',
    items: [
      {
        label: 'Frontespizio',
        icon: 'pi pi-file-pdf',
        to: '/registers',
        admit_user_levels: []
      },
      {
        label: 'Pagine',
        icon: 'pi pi-table',
        to: '/requests',
        admit_user_levels: []
      }
    ]
  }
])
</script>

<template>
  <ul class="layout-menu">
    <template v-for="(item, i) in model" :key="item">
      <app-menu-item
        v-if="!item.separator"
        :item="item"
        :index="i"
        :child-visible="isVisibleFromPermissions(item)"
      />
      <li v-if="item.separator" class="menu-separator"></li>
    </template>
  </ul>
</template>

<style lang="scss" scoped></style>
